import { EdgeTypes } from "@xyflow/react";

import { CustomEdge } from "./CustomEdge";
import { ZapStepEdge } from "./ZapStepEdge";

export const edgeTypes: EdgeTypes = {
  default: CustomEdge,
  zapStepEdge: ZapStepEdge,
};
